module.exports = __webpack_public_path__ + "static/media/corporate-services-img53.1065b993.jpg";